import { render } from "./Photo3.vue?vue&type=template&id=08bfc449"
import script from "./Photo3.vue?vue&type=script&lang=js"
export * from "./Photo3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__